<style lang="less" scoped>
.kyxmDetails{width: 1400px;height:700px;background-color: #fff;border: 1px solid rgb(206, 204, 204);}
.top{margin-top: 20px;text-align: left;margin-left: 35px;font-size: 19px;font-weight: bold;color: #0152b5;
  .i{color: #0152b5;font-weight: 1000;}
  .el-icon-close{float: right;margin-right: 30px;cursor: pointer;}}
.map{width: 96%;height: 84%;margin-left: 2%;margin-top: 10px;}
.floor{margin-top: 20px;}
</style>

<template>
<div class="kyxmDetails">
  <div class="top">´
      <i class="el-icon-chat-dot-square"></i>设置经纬度
      <i class="el-icon-close" @click="onclose"></i>
  </div>
  <div id="map" class="map"></div>
  <div class="floor">
      <!-- <el-button type="primary"  @click="setL()">设置</el-button> -->
      <el-radio-group v-model="radio" @change="onDataChange">
        <el-radio :label="1">点</el-radio>
        <el-radio :label="2">面</el-radio>
      </el-radio-group>
  </div>
</div>
   
</template>

<script>
/**
 * lx
 */
import 'ol/ol.css'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import View from 'ol/View'
import MousePosition from 'ol/control/MousePosition'
import {defaults as defaultControls} from 'ol/control'
import {createStringXY} from 'ol/coordinate'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import {Fill, Stroke, Style, Icon, Text} from 'ol/style'
import Draw from 'ol/interaction/Draw'
import Overlay from 'ol/Overlay'
import CircleStyle from 'ol/style/Circle'
import LineString from 'ol/geom/LineString'
import Polygon from 'ol/geom/Polygon'
import TileWMS from 'ol/source/TileWMS'
import WMTS from 'ol/source/WMTS'
import WMTSTileGrid from 'ol/tilegrid/WMTS'

import {getArea, getLength} from 'ol/sphere'
import {unByKey} from 'ol/Observable'
import {mapState} from 'vuex'
let draw
export default {
  name: '',
  data()
  {
    return {
      radio: null,
      LayernarData: [],
      measureAry: [],
      newdataid: ''
    }
  },
  computed: {
    ...mapState({
      curID: state => state.kyqtjid
    })
  },
  watch: {
    curID:
    {
      handler(nval, oval)
      {
        this.newdataid = nval
      },
      immediate: true
    }
  },
  mounted()
  {
    this.getDefultLayer()
    this.$nextTick(() =>
    {
      this.loadModules()
      //刷新窗口兼容IE
      setTimeout(() =>
      {
        window.map.updateSize()
      }, 1000)
    })
  },
  methods:
  {
    //加载底图
    loadModules()
    {
      var layer1 = new TileLayer({
        title: '矢量底图',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=vec_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: false
      })
      var layer2 = new TileLayer({
        title: '影像底图',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=img_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: true
      })
      var layer3 = new TileLayer({
        title: '中文注记',
        namee: 'ChineseNotes',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=cva_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: true
      })
      var layer4 = new TileLayer({
        title: '地形底图',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=ter_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: false
      })
      // 实例化鼠标位置控件
      const mousePositionControl = new MousePosition({
        coordinateFormat: createStringXY(9),
        projection: 'EPSG:4326',
        className: 'custom-mouse-position',
        target: 'map'
      })
      let map = new Map({
        target: 'map',
        layers: [layer1, layer2, layer4, layer3],
        overlays: [],
        view: new View({
          center: [108.21, 7.01],
          projection: 'EPSG:4326',
          zoom: 5
        }),
        controls: defaultControls().extend([mousePositionControl])
      })
      window.map = map
      this.Basemap = [{name: '矢量底图', layer: layer1}, {name: '卫星底图', layer: layer2}, {name: '地形底图', layer: layer4}]
    },
    getDefultLayer()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: 'id > 0 and glid = 914', orderby: 'id ASC'}
      window.post.getPost(paras).then((ret) =>
      {
        ret.forEach(item =>
        {
          this.loadWMTSlayer(item)
        })
      })
    },
    // 点击关闭
    onclose()
    {
      this.$parent.setL()
    },
    onDataChange(val)
    {
      if (val === 1)
        window.map.on('click', this.handler)
      else
        this.measure(window.map, 'area')
    },
    // 画点
    handler(evt)
    {
      let self = this
      let coordinate =  evt.coordinate
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 129,
        retAtt: 1,
        id: this.newdataid,
        drawtype: 1,
        lonlat: coordinate.toString()
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 0)
          this.$message({message: '设置成功', type: 'success', customClass: 'mzindex'})
      })
      var feature = new Feature({
        geometry: new Point(coordinate)
      })
      var vector = new VectorSource()
      var wfsVectorLayer = new VectorLayer({
        source: vector,
        style: new Style({
          fill: new Fill({
            color: 'rgba(0, 0, 0, 0.4)',
            width: 1
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 1
          }),
          image: new Icon({
            src: '../../../../../static/index/map-marker1.png'
          }),
          text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            font: ' 16px serif',
            text: '测试',
            offsetx: 0,
            offsetY: -30,
            fill: new Fill({
              color: '#23fffc'
            })
          })
        })
      })
      vector.addFeature(feature)
      self.LayernarData.push(wfsVectorLayer)
      window.map.addLayer(wfsVectorLayer)
    },
    // 画多边形
    measure(map, typeSelect)
    {
      let self = this
      //清除测量标记
      if (typeSelect === 'delete')
      {
        this.measureAry.forEach(e =>
        {
          e.getSource().clear()
        })
        //清除测量结果
        let tagging = document.getElementsByClassName('ol-tooltip')
        for (let i = 0; i < tagging.length; i++)
          tagging[i].style.display = 'none'
        return
      }
      const source = new VectorSource()
      const vector = new VectorLayer({
        source: source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 2
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33'
            })
          })
        })
      })
      this.measureAry.push(vector)
      /**
       * 目前绘制功能.
       * @type {import("../src/ol/Feature.js").default}
       */
      let sketch
      /**
       * 帮助工具提示元素。
       * @type {HTMLElement}
       */
      let helpTooltipElement
      /**
       * 覆盖显示帮助信息。
       * @type {Overlay}
       */
      let helpTooltip
      /**
       * 测量工具提示元素。
       * @type {HTMLElement}
       */
      let measureTooltipElement
      /**
       * 覆盖显示测量值。
       * @type {Overlay}
       */
      let measureTooltip
      /**
       * 消息显示用户正在绘制多边形。
       * @type {string}
       */
      /**
       * 消息，以显示用户何时正在绘制一条线。
       * @type {string}
       */
      /**
       * Handle pointer move.
       * @param {import("../src/ol/MapBrowserEvent").default} evt The event.
       */
      const pointerMoveHandler = function(evt)
      {
        if (evt.dragging)
          return
        /** @type {string} */
        let helpMsg = '点击开始绘图'
        helpTooltipElement.innerHTML = helpMsg
        helpTooltip.setPosition(evt.coordinate)
        helpTooltipElement.classList.remove('hidden')
      }
      map.addLayer(vector)
      map.on('pointermove', pointerMoveHandler)
      map.getViewport().addEventListener('mouseout', function()
      {
        helpTooltipElement.classList.add('hidden')
      })
      let seft = this
      /**
       * 格式输出长度.
       * @param {LineString} line The line.
       * @return {string} The formatted length.
       */
      const formatLength = function(line)
      {
        var sourceProj = map.getView().getProjection()//获取投影坐标系
        const length = getLength(line, {projection: sourceProj})
        let output
        if (length > 100)
          output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km'
        else
          output = Math.round(length * 100) / 100 + ' ' + 'm'
        seft.$store.commit('onMeasureNum', output)
        return output
      }
      /**
       * 格式输出
       * @param {Polygon} polygon The polygon.
       * @return {string} Formatted area.
       */
      const formatArea = function(polygon)
      {
        var sourceProj = map.getView().getProjection()//获取投影坐标系
        const area = getArea(polygon, {projection: sourceProj})
        let output
        if (area > 10000)
          output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>'
        else
          output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>'
        seft.$store.commit('onMeasureNum', output)
        return output
      }
      function addInteraction()
      {
        //开始选择绘制类型之前取消上次选择类型
        map.removeInteraction(draw)
        const type = typeSelect === 'area' ? 'Polygon' : 'LineString'
        draw = new Draw({
          source: source,
          type: type,
          style: new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.7)'
            }),
            stroke: new Stroke({
              color: 'rgba(255, 255, 255, 0.7)',
              lineDash: [10, 10],
              width: 2
            }),
            image: new CircleStyle({
              radius: 5,
              stroke: new Stroke({
                color: 'rgba(255, 255, 255, 0.7)'
              }),
              fill: new Fill({
                color: 'rgba(255, 255, 255, 0.7)'
              })
            })
          })
        })
        map.addInteraction(draw)
        createMeasureTooltip()
        createHelpTooltip()
        let listener
        draw.on('drawstart', function(evt)
        {
          //开始绘制时，设置当前结果颜色
          measureTooltipElement.style.color = 'rgba(255,255,255,.9)'
          //开始绘制时，设置提示颜色
          helpTooltipElement.style.color = 'rgba(255,255,255,.9)'
          sketch = evt.feature
          /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
          let tooltipCoord = evt.coordinate
          listener = sketch.getGeometry().on('change', function(evt)
          {
            const geom = evt.target
            let output
            if (geom instanceof Polygon)
            {
              output = formatArea(geom)
              tooltipCoord = geom.getInteriorPoint().getCoordinates()
            }
            else if (geom instanceof LineString)
            {
              output = formatLength(geom)
              tooltipCoord = geom.getLastCoordinate()
            }
            seft.$store.commit('onMeasureNum', output)
            measureTooltipElement.innerHTML = output
            measureTooltip.setPosition(tooltipCoord)
          })
        })
        draw.on('drawend', function(e)
        {
          const geometry = e.feature.getGeometry()
          const corrdinates = geometry.getCoordinates()
          let data = []
          for (let i = 0; i < corrdinates[0].length; i++)
          
            data.push(corrdinates[0][i].toString())
          let obj = {
            cmd: 'updateAtt',
            _major: 11,
            _minor: 129,
            retAtt: 1,
            id: self.newdataid,
            drawtype: 2,
            lonlat: data.join(';')
          }
          window.post.getPost(obj).then((ret) =>
          {
            if (ret.ret === 0)
              seft.$message({message: '设置成功', type: 'success', customClass: 'mzindex'})
          })
          //右键确认时设置当前当算量算结果的颜色
          measureTooltipElement.style.color = '#FFCC33'
          measureTooltip.setOffset([0, -7])
          // 未设置的草图
          sketch = null
          // 取消设置工具提示以便创建新的工具提示
          measureTooltipElement = null
          createMeasureTooltip()
          unByKey(listener)
          map.un('pointermove', pointerMoveHandler)
          map.removeInteraction(draw)
          helpTooltipElement.classList.add('hidden')
          //画完线后清空提示
          helpTooltipElement.innerHTML = ''
        })
      }
      /**
       * 创建一个新的帮助提示
       */
      function createHelpTooltip()
      {
        if (helpTooltipElement)
          helpTooltipElement.parentNode.removeChild(helpTooltipElement)
        helpTooltipElement = document.createElement('div')
        helpTooltipElement.className = 'ol-tooltip hidden'
        helpTooltip = new Overlay({
          element: helpTooltipElement,
          offset: [15, 0],
          positioning: 'center-left'
        })
        map.addOverlay(helpTooltip)
      }
      /**
       * 创建一个新的度量工具提示
       */
      function createMeasureTooltip()
      {
        if (measureTooltipElement)
          measureTooltipElement.parentNode.removeChild(measureTooltipElement)
        measureTooltipElement = document.createElement('div')
        measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure'
        measureTooltip = new Overlay({
          element: measureTooltipElement,
          offset: [0, -15],
          positioning: 'bottom-center',
          stopEvent: false,
          insertFirst: false
        })
        map.addOverlay(measureTooltip)
      }
      addInteraction()
    },
    //加载arcgis切片图层
    loadWMTSlayer(node)
    {
      if (node.filter !== 'WMS')
        return false
      let layer = node.type.split(':')[1].split('_')[1]
      let resolutions = []
      if ((node.glid === 914 && node.namec === '柬埔寨矿权') || node.namee === 'Cambodia2')
        resolutions = [0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772, 0.0002974141339366386, 0.0001487070669683193, 0.00007435353348415965]
      else if (node.glid === 914 && node.namec === '印度尼西亚矿权')
        resolutions = [0.03806900914388974, 0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772, 0.0002974141339366386]
      else if (node.glid === 914 || node.namee === 'Vietnam1')
        resolutions = [0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772, 0.0002974141339366386, 0.0001487070669683193]
      else if (node.glid === 870 && node.namec !== '机场')
        resolutions = [0.07613801828777948, 0.03806900914388974, 0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772]
      else
        resolutions = [0.15227603657555896, 0.07613801828777948, 0.03806900914388974, 0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544]
      var tileGridWMTS = new WMTSTileGrid({
        resolutions: resolutions,
        //原点
        origin: [-400, 400],
        tileSize: 256,
        matrixIds: [`${node.type}:0`, `${node.type}:1`, `${node.type}:2`, `${node.type}:3`, `${node.type}:4`, `${node.type}:5`, `${node.type}:6`, `${node.type}:7`]
      })
      var smOption = {
        tileGrid: tileGridWMTS,
        matrixSet: node.type,
        projection: 'EPSG:4326',
        layer: layer,
        style: '',
        version: '1.0.0',
        format: 'image/png',
        transition: 0,
        opaque: 0,
        url: 'http://www.camining.cn/geowebcache/service/wmts'
      }
      var lyr = new TileLayer({
        title: node.namec,
        namee: node.name,
        source: new WMTS(smOption)
      })
      window.map.addLayer(lyr)
    },
    showLegend(node)
    {
      let layers
      //加载wms图层
      if (node.filter === 'WMS')
      {
        const wmsSource = new TileWMS({
          url: 'http://www.camining.cn/geoserver/gisdny/wms',
          params: {
            LAYERS: node.maptype
          },
          className: 'tucheng'
        })
        // if (checked)
        //   this.imgary.push({img: node.icon, id: node.id})
        // else
        // {
        //   let index = this.imgary.findIndex(e => e.id === node.id)
        //   this.imgary.splice(index, 1)
        // }
        layers =  new TileLayer({
          title: node.namec,
          namee: node.name,
          source: wmsSource,
          visible: true
        })
      }
      //加载天地图
      else if (node.filter === 'XYZ')
      {
        layers = new TileLayer({
          title: node.namec,
          namee: node.name,
          source: new XYZ({
            url: node.url
          }),
          visible: true
        })
      }
      return layers
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/mapPoint.vue